import React, { useEffect, useState } from "react";
import "./CampignCard.css";
import Icon from "../../../../../components/Icon";
import moment from "moment";
import { truncate } from "lodash";
import { showNotification } from "../../../../../util/Utility";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const PAST_CAMPAIGNS = "pastCampaigns";
const ADD_CAMPAIGN = "addCampaign";

const encryptData = (data) => {
  if (!data) return;
  return btoa(data);
};

const CampaignCard = ({
  data,
  shouldReorder,
  setClickedCard,
  setShowTrackModal,
}) => {
  const [isActive, setIsActive] = useState(false);
  const [copied, setCopied] = useState(false);
  const { t, i18n } = useTranslation();
  const agent = useSelector((state) => state.appReducer.user);
  const userType = localStorage.getItem("user_type");
  const handleSwitch = async (e) => {
    e.stopPropagation();
    try {
      const newActiveState = !isActive;
      const update = {
        is_active: newActiveState,
      };
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}donation/edit-campaign?campaignId=${data._id}`,
        update
      );
      console.log(res);
      setIsActive(newActiveState);
      showNotification("success", "Updated success");
    } catch (error) {
      showNotification("error", "Some error occured..");
    }
  };
  const handleTrackClick = async (e) => {
    e.stopPropagation();
    setClickedCard(data);
    setShowTrackModal(true);
  };

  useEffect(() => {
    setIsActive(data?.is_active);
  }, [data]);

  const handleShareClick = async (e) => {
    e.stopPropagation();
    const shareLink = `${process.env.REACT_APP_SERVER_URL}/donation-form?campaignId=${data?._id}&language=${i18n.language}&shareId=${encodeURIComponent(encryptData(agent?._id))}`;
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(shareLink);
      } else {
        // fallback: create temporary textarea
        const textarea = document.createElement("textarea");
        textarea.value = shareLink;
        textarea.style.position = "fixed"; 
        textarea.style.opacity = "0"; 
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <div
      style={{
        position: "relative",
        pointerEvents: userType === "viewer" ? "none" : "",
      }}
      onClick={() => setClickedCard(data)}
    >
      {/* <div style={{display:(data?.isCompleted)?'none':'flex',justifyContent:'center', position:'absolute', top:'-5px', zIndex:1000,left:'140px'}}><Icon iconName="dragIcon"/></div> */}
      <div className="product-card">
        <div className="image-container">
          <img
            src={data.preview_image} // Replace with the actual image URL
            alt={data.preview_image_alt}
            className="product-image"
          />
        </div>
        <div className="card-content">
          <div className="top-row">
            <button
              style={{ pointerEvents: userType === "viewer" ? "auto" : "" }}
              onClick={handleTrackClick}
              className="track-button"
            >
              {t("TRACK")}
            </button>
            {data.is_completed ? (
              <div className="completed">
                <Icon iconName="completedIcon" /> {t("Completed")}
              </div>
            ) : (
              <label
                className="switch"
                style={{ marginTop: "-5px", marginRight: "5px" }}
                onClick={(e) => e.stopPropagation()}
              >
                <input
                  type="checkbox"
                  style={{ fontSize: "20px" }}
                  checked={isActive}
                  onClick={handleSwitch}
                />
                <span className="slider round"></span>
              </label>
            )}
          </div>
          <p className="product-description">
            {truncate(data.title, { length: 30 })}
          </p>
          <div className="price-date">
            <span className="price">€{data.amount}</span>
            {/* <span className='line'></span> */}
            {data?.published_date && (
              <span className="date">
                {moment(new Date(data?.published_date)).format("MMM DD, YYYY")}
              </span>
            )}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <button
            disabled={data?.is_completed}
            onClick={handleShareClick}
            className={
              data?.is_completed
                ? "btn-outline-primary btn-disabled"
                : "btn-outline-primary"
            }
          >
            {t("Share with member")}
          </button>
          {copied && (
            <div className="link-copied">
              <span style={{ color: "limegreen", fontSize: "14px" }}>✔</span>
              &nbsp; &nbsp; {t("Link copied to clipboard")}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CampaignCard;
